/**
 * Section scripts: moved from {% javascript %} to avoid Shopify scripts.js bundle error.
 * Each block runs only when its section DOM is present.
 */
(function () {
  function runWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function switchToFallback(container) {
    var figure = container.querySelector('.figure-media');
    if (!figure) return false;
    var videoContainer = figure.querySelector('.media-video-container');
    var fallback = figure.querySelector('.media-fallback');
    if (videoContainer) videoContainer.style.display = 'none';
    if (fallback) {
      fallback.removeAttribute('hidden');
      fallback.setAttribute('aria-hidden', 'false');
      container.classList.add('is-video-ready');
    }
    return fallback != null;
  }

  function hideVideoOnly(container) {
    var figure = container.querySelector('.figure-media');
    if (!figure) return false;
    var videoContainer = figure.querySelector('.media-video-container');
    if (videoContainer) videoContainer.style.display = 'none';
    return true;
  }

  runWhenReady(function () {
    var root = document.getElementById('page-loader-root');
    var intro = document.getElementById('page-loader-intro');
    var transition = document.getElementById('page-loader-transition');
    if (!root || !intro || !transition) return;

    var currentPageType = (root.dataset.pageType || '').toLowerCase();
    var MIN_MS = 500;
    var EXIT_DURATION_MS = 200;
    var MAX_LOADER_MS = 4000;
    var introSeenKey = 'page-loader-intro-seen';
    var productTransitionSeenKey = 'page-loader-product-transition-seen';
    var collectionTransitionSeenKey = 'page-loader-collection-transition-seen';

    function getIntroSeen() {
      try {
        if (sessionStorage.getItem(introSeenKey)) return true;
      } catch (e) {}
      try {
        if (localStorage.getItem(introSeenKey)) return true;
      } catch (e) {}
      return false;
    }

    function markIntroSeen() {
      try { sessionStorage.setItem(introSeenKey, '1'); } catch (e) {}
      try { localStorage.setItem(introSeenKey, '1'); } catch (e) {}
    }

    function getProductTransitionSeen() {
      try {
        if (sessionStorage.getItem(productTransitionSeenKey)) return true;
      } catch (e) {}
      return false;
    }

    function markProductTransitionSeen() {
      try { sessionStorage.setItem(productTransitionSeenKey, '1'); } catch (e) {}
    }

    function getCollectionTransitionSeen() {
      try {
        if (sessionStorage.getItem(collectionTransitionSeenKey)) return true;
      } catch (e) {}
      return false;
    }

    function markCollectionTransitionSeen() {
      try { sessionStorage.setItem(collectionTransitionSeenKey, '1'); } catch (e) {}
    }

    function isProductOrCollection(t) {
      return t === 'product' || t === 'collection';
    }

    function forceHideLoader() {
      root.classList.add('page-loader-root--hidden');
    }

    function showLoaderRoot() {
      root.classList.remove('page-loader-root--hidden');
    }

    function revealVideoWhenReady(container, onCanPlay) {
      var videos = container.querySelectorAll('video');
      function reveal() {
        container.classList.add('is-video-ready');
        if (typeof onCanPlay === 'function') onCanPlay();
      }
      videos.forEach(function (v) {
        if (v.readyState >= 2) reveal();
        else v.addEventListener('canplay', reveal, { once: true });
      });
    }

    function playVideos(container) {
      container.querySelectorAll('video').forEach(function (v) { v.play().catch(function () {}); });
    }

    function onExitTransitionEnd(el, callback) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        el.removeEventListener('transitionend', finish);
        callback();
      }
      el.addEventListener('transitionend', finish);
      setTimeout(finish, EXIT_DURATION_MS + 50);
    }

    function hideTransition() {
      transition.classList.add('is-exiting');
      onExitTransitionEnd(transition, function () {
        transition.classList.remove('is-visible', 'is-exiting');
        forceHideLoader();
      });
    }

    function hideIntro() {
      // Mark intro as seen immediately to avoid iOS edge-cases where `transitionend`
      // might be delayed and cause the loader to incorrectly show the intro again.
      markIntroSeen();
      intro.classList.add('is-exiting');
      onExitTransitionEnd(intro, function () {
        forceHideLoader();
      });
    }

    function runLoader(container, mediaType, onComplete) {
      mediaType = (mediaType || 'none').toLowerCase();
      var pageReady = false;
      var minimumDone = false;
      var completed = false;
      var usingFallback = false;

      function done() {
        if (completed) return;
        completed = true;
        onComplete();
      }

      var maxTimeout = setTimeout(function () { done(); }, MAX_LOADER_MS);

      function tryComplete() {
        if (pageReady && minimumDone) {
          clearTimeout(maxTimeout);
          done();
        }
      }

      function setPageReady() {
        pageReady = true;
        tryComplete();
      }

      if (mediaType === 'image' || mediaType === 'none') {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', setPageReady);
        } else {
          setPageReady();
        }
        setTimeout(function () { minimumDone = true; tryComplete(); }, MIN_MS);
        return;
      }

      if (mediaType === 'video') {
        var videos = container.querySelectorAll('video');
        if (videos.length === 0) {
          minimumDone = true;
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setPageReady);
          } else {
            setPageReady();
          }
          return;
        }

        // Hide video UI immediately so iOS never shows the native paused play overlay.
        // While waiting for the video to become playable, reveal the fallback image
        // in the exact same spot as the video.
        hideVideoOnly(container);

        var fallbackEls = container.querySelectorAll('.media-fallback');
        fallbackEls.forEach(function (f) {
          f.removeAttribute('hidden');
          f.setAttribute('aria-hidden', 'false');
        });
        // Make the figure visible even before the video is ready.
        container.classList.add('is-video-ready');

        // Ensure we can reliably observe `ended` and prevent looping.
        videos.forEach(function (v) { v.loop = false; });

        var started = false;
        var completedByNearEnd = false;

        function showVideoUI() {
          if (started) return;
          started = true;
          container.classList.add('is-video-ready');
          // Hide fallback once the video is actually playing.
          fallbackEls.forEach(function (f) {
            f.setAttribute('hidden', '');
            f.setAttribute('aria-hidden', 'true');
          });
          var figure = container.querySelector('.figure-media');
          if (figure) {
            var videoContainer = figure.querySelector('.media-video-container');
            if (videoContainer) videoContainer.style.display = '';
          }
        }

        function maybeCompleteNearEnd() {
          if (completedByNearEnd) return;
          videos.forEach(function (v) {
            var dur = v.duration;
            var t = v.currentTime;
            if (!dur || !isFinite(dur)) return;
            if (dur - t <= 0.25) {
              completedByNearEnd = true;
              minimumDone = true;
              tryComplete();
            }
          });
        }

        function isActuallyProgressing() {
          for (var i = 0; i < videos.length; i++) {
            var v = videos[i];
            if (!v) continue;
            if ((v.currentTime || 0) > 0.05) return true;
            var bufferedEnd = 0;
            try {
              if (v.buffered && v.buffered.length) bufferedEnd = v.buffered.end(v.buffered.length - 1);
            } catch (e) {}
            if (bufferedEnd > 0.05) return true;
          }
          return false;
        }

        videos.forEach(function (v) {
          v.addEventListener('playing', function () {
            showVideoUI();
          });
          v.addEventListener('timeupdate', function () {
            if (!started && (v.currentTime || 0) > 0.05) showVideoUI();
            if (started) maybeCompleteNearEnd();
          });
          v.addEventListener('ended', function () {
            if (completedByNearEnd) return;
            completedByNearEnd = true;
            minimumDone = true;
            tryComplete();
          });
          v.addEventListener('error', function () {
            if (started) return;
            minimumDone = true;
            tryComplete();
          }, { once: true });

          try { v.currentTime = 0; } catch (e) {}
          v.play().catch(function () {});
        });

        // Autoplay probe: if after 500ms nothing is progressing, finish (keep video hidden).
        var autoplayProbeMs = 500;
        setTimeout(function () {
          if (started || minimumDone) return;
          if (isActuallyProgressing()) return;
          minimumDone = true;
          tryComplete();
        }, autoplayProbeMs);

        // Page readiness gate:
        // For video we don't want to wait for DOMContentLoaded on iOS (low power/autoplay may delay it),
        // so we mark the page as ready immediately and let the minimumDone timer control exit.
        setTimeout(setPageReady, 0);
        return;
      }

      minimumDone = true;
      setPageReady();
    }

    setTimeout(function () { forceHideLoader(); }, MAX_LOADER_MS);

    var introMediaType = (intro.dataset.introMedia || 'none').toLowerCase();
    var transitionMediaType = (transition.dataset.transitionMedia || 'none').toLowerCase();
    var hasSeenIntro = getIntroSeen();

    var shouldShowIntro = !hasSeenIntro && introMediaType !== 'none';
    var shouldShowTransition =
      hasSeenIntro &&
      isProductOrCollection(currentPageType) &&
      transitionMediaType !== 'none' &&
      !(currentPageType === 'product' && getProductTransitionSeen()) &&
      !(currentPageType === 'collection' && getCollectionTransitionSeen());

    if (!shouldShowIntro && !shouldShowTransition) {
      forceHideLoader();
      return;
    }

    if (shouldShowIntro) {
      // Mark intro as seen immediately so quick navigations or iOS timing quirks
      // can't cause the intro background to show again.
      markIntroSeen();
      showLoaderRoot();
      runLoader(intro, introMediaType, function () {
        intro.querySelectorAll('video').forEach(function (v) { v.pause(); });
        hideIntro();
      });
      return;
    }

    // Transition mode (first product/collection visit per session).
    if (currentPageType === 'product') {
      markProductTransitionSeen();
    } else if (currentPageType === 'collection') {
      markCollectionTransitionSeen();
    }
    showLoaderRoot();
    intro.classList.add('is-exiting');
    transition.classList.add('is-visible');
    runLoader(transition, transitionMediaType, function () {
      transition.querySelectorAll('video').forEach(function (v) { v.pause(); });
      hideTransition();
    });
  });

  runWhenReady(function () {
    if (!document.documentElement.classList.contains('snap-fullscreen')) return;
    if (window.__fullscreenTitleObserved) return;
    window.__fullscreenTitleObserved = true;

    var sections = document.querySelectorAll('.module-fullscreen');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.5 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  });

  runWhenReady(function () {
    var sections = document.querySelectorAll('.module-waterfall');
    if (!sections.length) return;

    function updateMediaForViewport() {
      sections.forEach(function (section) {
        var desktopMedia = section.querySelector('.waterfall-media-desktop');
        var mobileMedia = section.querySelector('.waterfall-media-mobile');
        if (desktopMedia && mobileMedia) {
          if (window.innerWidth < 820) {
            desktopMedia.style.display = 'none';
            mobileMedia.style.display = 'block';
          } else {
            desktopMedia.style.display = 'block';
            mobileMedia.style.display = 'none';
          }
        }
      });
    }

    function initwaterfallTitleObserver() {
      if (!document.documentElement.classList.contains('snap-waterfall')) return;
      if (window.__waterfallTitleObserved) return;
      window.__waterfallTitleObserved = true;

      var obsSections = document.querySelectorAll('.module-waterfall');
      if (!obsSections.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            } else {
              entry.target.classList.remove('is-visible');
            }
          });
        },
        { root: null, rootMargin: '0px', threshold: 0.5 }
      );

      obsSections.forEach(function (section) {
        observer.observe(section);
      });
    }

    function initWaterfallBlockTabs() {
      var allTitles = document.querySelectorAll('.waterfall-blocks-container .block-title');
      var allContents = document.querySelectorAll('.waterfall-blocks-container .block-content');
      if (allTitles.length === 0) return;

      allContents.forEach(function (content, index) {
        content.style.display = index === 0 ? 'block' : 'none';
      });
      allTitles[0].classList.add('active');

      allTitles.forEach(function (title) {
        title.addEventListener('click', function () {
          var tabIndex = this.getAttribute('data-tab');
          allTitles.forEach(function (t) { t.classList.remove('active'); });
          allContents.forEach(function (content) { content.style.display = 'none'; });
          this.classList.add('active');
          var targetContent = document.querySelector('[data-tab-content="' + tabIndex + '"]');
          if (targetContent) targetContent.style.display = 'block';
        });
      });
    }

    updateMediaForViewport();
    initwaterfallTitleObserver();
    initWaterfallBlockTabs();
    window.addEventListener('resize', updateMediaForViewport);
  });

  runWhenReady(function () {
    var root = document.getElementById('screensaver-root');
    var overlay = document.getElementById('screensaver-overlay');
    if (!root || !overlay) return;
    if (root.dataset.styleOnly === 'true') return;

    var enabled = root.dataset.enabled === 'true';
    var idleMs = parseInt(root.dataset.idleMs, 10);
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!enabled || !idleMs || idleMs < 0 || prefersReducedMotion) return;

    var timeoutId = null;
    var throttleId = null;
    var lastResetAt = 0;
    var THROTTLE_MS = 250;

    function isFormControl(el) {
      if (!el || !el.tagName) return false;
      var tag = el.tagName.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
      return el.getAttribute('contenteditable') === 'true';
    }

    function showFallbackIfPresent() {
      switchToFallback(overlay);
    }

    function playVideos() {
      function setVideoAndFallbackVisibility(showVideo) {
        overlay.querySelectorAll('.media-video-container').forEach(function (el) {
          el.style.display = showVideo ? '' : 'none';
        });
        overlay.querySelectorAll('.media-fallback').forEach(function (f) {
          if (showVideo) {
            // Hide fallback when video is actually playing.
            f.setAttribute('hidden', '');
            f.setAttribute('aria-hidden', 'true');
          } else {
            // Show fallback while the video is waiting (e.g. low power mode).
            f.removeAttribute('hidden');
            f.setAttribute('aria-hidden', 'false');
          }
        });
      }

      var videos = overlay.querySelectorAll('video');
      var started = false;

      // Hide the video element immediately so iOS doesn't render the native play overlay.
      setVideoAndFallbackVisibility(false);

      function markStartedIfPlaying() {
        if (started) return;
        videos.forEach(function (v) {
          if (v.currentTime > 0.05 && !v.paused) started = true;
        });
        if (started) setVideoAndFallbackVisibility(true);
      }

      videos.forEach(function (video) {
        try { video.currentTime = 0; } catch (e) {}
        // If autoplay fails, keep video hidden and do NOT reveal the fallback poster.
        video.addEventListener('error', function () {
          setVideoAndFallbackVisibility(false);
        }, { once: true });
        video.addEventListener('playing', function () {
          started = true;
          setVideoAndFallbackVisibility(true);
        });
        video.addEventListener('timeupdate', markStartedIfPlaying);
        video.play().catch(function () {});
      });

      // If it never truly starts, show fallback (if we have one). If not, it stays hidden.
      setTimeout(function () {
        if (started) return;
        // If it never truly starts, keep the video hidden and keep the fallback image visible.
        setVideoAndFallbackVisibility(false);
      }, 500);
    }

    function stopVideos() {
      overlay.querySelectorAll('video').forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
      overlay.querySelectorAll('.media-video-container').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    function show() {
      if (document.visibilityState === 'hidden') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (isFormControl(document.activeElement)) {
        scheduleShow();
        return;
      }
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      playVideos();
    }

    function hide() {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      stopVideos();
      scheduleReset();
    }

    function scheduleShow() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(show, idleMs);
    }

    function scheduleReset() {
      clearTimeout(timeoutId);
      timeoutId = null;
      scheduleShow();
    }

    function resetTimerThrottled() {
      var now = Date.now();
      if (now - lastResetAt < THROTTLE_MS) {
        if (!throttleId) {
          throttleId = setTimeout(function () {
            throttleId = null;
            lastResetAt = Date.now();
            scheduleReset();
          }, THROTTLE_MS - (now - lastResetAt));
        }
        return;
      }
      lastResetAt = now;
      if (throttleId) {
        clearTimeout(throttleId);
        throttleId = null;
      }
      scheduleReset();
    }

    function onActivity() {
      if (overlay.classList.contains('is-visible')) {
        hide();
      } else {
        resetTimerThrottled();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        e.preventDefault();
        hide();
        return;
      }
      onActivity();
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        clearTimeout(timeoutId);
        timeoutId = null;
        if (throttleId) {
          clearTimeout(throttleId);
          throttleId = null;
        }
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        stopVideos();
      } else {
        lastResetAt = Date.now();
        scheduleReset();
      }
    }

    ['mousemove', 'mousedown', 'touchstart', 'scroll', 'wheel'].forEach(function (type) {
      document.addEventListener(type, onActivity, { passive: true });
    });
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('visibilitychange', onVisibilityChange);

    lastResetAt = Date.now();
    scheduleReset();
  });

  window.addEventListener('load', function () {
    var productRecommendationsSection = document.querySelector('.related-products-container');
    if (!productRecommendationsSection) return;

    var url = productRecommendationsSection.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.related-products-container');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(function (e) { console.error(e); });
  });
})();
